import { getCurrentUser, signInWithRedirect, signOut } from "aws-amplify/auth";
import { selectAuthenticatedUserRoles, selectAuthenticatedUserSessionID, clearUserData, setUserAttributes } from "./slices";
import { fetchApplicationRoles, fetchCurrentSession, getRedirectParams } from "../../util/login";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { sliceNames } from "../util/constants";
import { parseOSUID } from "../../util/functions";

const name = sliceNames.authentication

export const syncAuthState = createAsyncThunk(
  `${name}/syncUserAttributes`,
  async (arg, { dispatch, getState, rejectWithValue }) => {
    try {
      let session = await fetchCurrentSession() || {};
      if(!session?.osuid) {
        session.osuid = parseOSUID(session)
      }
      if (!session?.osuid) {
        throw new Error("User not authenticated properly");
      }
      const existingState = getState()
      const currentUserId = selectAuthenticatedUserSessionID(existingState);
      const existingRoles = selectAuthenticatedUserRoles(existingState);
      let roles = session?.["cognito:groups"] || []
      if(!roles?.length) {
        roles = await fetchApplicationRoles()
      }
      const rolesSame = roles?.length === existingRoles?.length
        && roles?.every((role) => existingRoles?.includes(role))
      
      const shouldReduxBeRefreshed =
        !currentUserId 
        || currentUserId !== session.sub
        || !rolesSame
      const storeAttributes = {
          ...session,
          roles
        }
      if (shouldReduxBeRefreshed) {
        dispatch(setUserAttributes(storeAttributes));
      }

      return storeAttributes;
    } catch (error) {
      console.error("Error handling user sign in:", error);
      
      
      return rejectWithValue(error.message);
    }
  }
);

const _logout = async (dispatch, logoutOptions) => {
  await signOut(logoutOptions);
  dispatch(clearUserData());
  return { success: true };
};

export const handleLogout = createAsyncThunk(
  `${name}/handleLogout`,
  async (options = {}, { dispatch, rejectWithValue }) => {
    const logoutOptions = options || {};

    try {
      return await _logout(dispatch, logoutOptions);
    } catch (firstError) {
      console.error("handleLogout Error logging out, retrying once:", firstError);
      await new Promise(resolve => setTimeout(resolve, 1000));
      try {
        return await _logout(dispatch, logoutOptions);
      } catch (secondError) {
        console.error("handleLogout Error logging out after retry:", secondError);
        dispatch(clearUserData());
        return rejectWithValue(secondError.message);
      }
    }
  }
);


export const handleLogin = createAsyncThunk(
  `${name}/handleLogin`,
  async (redirectPath, { rejectWithValue, fulfillWithValue }) => {
    let isLoggedIn;
    try {
      const currentUser = await getCurrentUser();
      isLoggedIn = !!currentUser?.username;
    } catch (error) {
      isLoggedIn = false;
    }
    if (isLoggedIn) {
      const fulfilled = {
        success: true,
        message: "Already logged in",
      };
      fulfillWithValue(fulfilled);
      return fulfilled;
    }
    try {
      const params = getRedirectParams(redirectPath);
      return await signInWithRedirect(params);
    } catch (error) {
      return rejectWithValue(error?.message || error);
    }
  }
);
